import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const TeachersPaymentService = {
  getAll,
  getTeachersList,
  addTeacher,
  getHoursListByTeacherId,
  getPaymentListByTeacherId,
  addTeacherHourCapture,
  approve_or_reject_hour_capture,
  addTeacherPayment,
  updateTeacher,
  deleteTeacher,
  deleteTeacherHour,
  deleteTeacherPayment,
};

async function addTeacher(teacher) {

  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(teacher)
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/add`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}

async function getAll(node_mid,lg_user_id, lg_user_table_id,owner_restriction,limit,offset,sort_column,sort_direction,search_term) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/getAll/${node_mid}/${lg_user_id}/${lg_user_table_id}/${limit}/${offset}?owner_restriction=${owner_restriction}&sort_column=${sort_column}&sort_direction=${sort_direction}&search_term=${search_term}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getTeachersList(node_mid,lg_user_id,lg_user_table_id,form_id) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/get_teachers_list/${node_mid}/${lg_user_id}/${lg_user_table_id}/${form_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getHoursListByTeacherId(id,node_mid,limit,offset,sort_column,sort_direction) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/get_hours_list_by_teacher_id/${id}/${node_mid}/${limit}/${offset}/${sort_column}/${sort_direction}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getPaymentListByTeacherId(id,node_mid,limit,offset,sort_column,sort_direction) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/get_payment_list_by_teacher_id/${id}/${node_mid}/${limit}/${offset}/${sort_column}/${sort_direction}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function addTeacherHourCapture(teacher_hour_capture) {

  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(teacher_hour_capture)
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/add_teacher_hour_capture`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}

async function approve_or_reject_hour_capture(type,id) {

  const configOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/approve_or_reject_hour_capture/${type}/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}

async function addTeacherPayment(teacher_payment) {

  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(teacher_payment)
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/add_teacher_payment`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}

async function updateTeacher(teacher,id) {

  const configOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(teacher)
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/update/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}

async function deleteTeacher(id) {

  const configOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/delete/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}

async function deleteTeacherHour(id) {

  const configOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/delete_hour/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}

async function deleteTeacherPayment(id) {

  const configOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/teacher_payment/delete_payment/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);

}